import { TokensPackProductModel } from "../models/products.models";

export class TokensPack {

    constructor(private toKensPack: TokensPackProductModel) {}

    get id(): string {
        return this.toKensPack.id;
    }

    get name(): string {
        return this.toKensPack.name;
    }

    get description(): string {
        return this.toKensPack.description;
    }

    get image(): string {
        return this.toKensPack.images && this.toKensPack.images.length > 0 ? this.toKensPack.images[0] : '';
    }

    get tokensQuantity(): number {
        return parseInt(this.toKensPack.metadata.tokens_quantity, 10) || 0;
    }

    get icon(): string {
    switch (this.toKensPack.name.toLowerCase()) {
      case 'pack flash':
        return 'zap';
      case 'pack core':
        return 'cpu';
      case 'pack boost':
        return 'chevrons-up';
      case 'pack prime':
        return 'gem';
      case 'pack ultimate':
        return 'atom';
      default:
        return 'package-open';
    }
  }

    get price():string{

        switch(this.toKensPack.price_list[0].currency){
            case 'eur':
                return `${this.toKensPack.price_list[0].unit_amount / 100} €`;
            case 'usd':
                return `${this.toKensPack.price_list[0].unit_amount / 100} $`;
            default:
                return this.toKensPack.price_list[0].currency;
        }
    }

    get priceId(): string {
        const priceList = this.toKensPack.price_list;
            return priceList[0].id;    
    }

}
